import React, { useContext, useMemo, useState } from 'react';
import { AccountContext } from "../AccountContext";
import { toCurrency, toFormattedDate } from "../../../utilities/FormatHelpers";
import { isCancelled } from "./RegularPaymentHelpers"

export function RegularPayment(props: { regularPayment: any, onCancel }) {
    const [cancelling, setCancelling] = useState(false as boolean);
    const { accountId, regularPaymentService, setError } = useContext(AccountContext);
    const regularPayment = props.regularPayment;

    const onCancelClicked = async () => {
        try {
            setCancelling(true);
            await regularPaymentService.cancelRegularPayment(accountId);
            props.onCancel();
            setCancelling(false);
        } catch (error) {
            setCancelling(false);
            setError({ source: "Cancel Regular Payment", ...error });
        }
    };

    const regularPaymentDetail = useMemo(() => regularPayment?.planned ?? regularPayment?.current, [regularPayment]);

    return <>
        <h2>Regular Payments</h2>
        {!regularPayment && <>
            <p>No Regular Payments Set Up</p>
        </>}
        {regularPayment &&
            <table className="ui compact table" style={{ marginBottom: "20px" }}>
                <thead>
                    <tr>
                        <th>SortCode</th>
                        <th>Account Number</th>
                        <th>Effective Dates</th>
                        <th>Last Updated</th>
                        <th>Payment Type</th>
                        {regularPaymentDetail.fixedAmount?.value > 0 && <th>Fixed Amount</th>}
                        <th>Status</th>
                        <th>Reference</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{regularPaymentDetail?.sortCode}</td>
                        <td>{regularPaymentDetail?.bankAccountNumber}</td>
                        <td>{toFormattedDate(regularPaymentDetail?.firstCollectionDate)}</td>
                        <td>{toFormattedDate(regularPaymentDetail?.lastUpdatedDate)}</td>
                        <td>{regularPaymentDetail?.paymentType}</td>
                        {regularPaymentDetail?.fixedAmount?.value > 0 && <td>{toCurrency(regularPaymentDetail?.fixedAmount?.value)}</td>}
                        <td>{regularPaymentDetail?.status}</td>
                        <td>{regularPayment.reference}</td>
                        <td className="collapsing">
                            {!isCancelled(regularPayment) && (
                                <div className="ui actions">
                                    <button className={`ui button ${cancelling && "loading"}`} style={{ marginRight: "2px" }}
                                        onClick={() => onCancelClicked()}>Cancel
                                    </button>
                                </div>)}
                        </td>
                    </tr>
                </tbody>
            </table>}
    </>;
}
